export const features = [
  {
    icon: "bi-pie-chart-fill",
    title: "Lot Size Calculator",
    description:
      "Calculate optimal position size based on your risk parameters",
    path: "/lotsize",
    color: "info",
    gradient: "linear-gradient(135deg, #0d6efd, #6f42c1)",
  },
  {
    icon: "bi-graph-up",
    title: "Pips Calculator",
    description: "Measure price movements in pips between two price points",
    path: "/pips",
    color: "success",
    gradient: "linear-gradient(135deg, #198754, #20c997)",
  },
  {
    icon: "bi-currency-dollar",
    title: "Profit Calculator",
    description: "Estimate potential profit/loss from your trades",
    path: "/profit",
    color: "warning",
    gradient: "linear-gradient(135deg, #fd7e14, #dc3545)",
  },
];
